export const crossDomainMark = (
  ...args: Parameters<typeof performance.mark>
) => {
  // TODO: [PAYIN-5228] Store the mark in a cookie to retrieve it on the new payment domain
  performance.mark(...args)
}
